// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-button {
  font-family: "Roboto-Medium";
}

.px-16px {
  padding-left: 16px;
  padding-right: 16px;
}

.py-16px {
  padding-top: 16px;
  padding-bottom: 16px;
}

.p-16px {
  padding: 16px;
}

.pr-16px {
  padding-right: 16px !important;
  padding-inline-end: 16px !important;
}

.pl-16px {
  padding-left: 16px !important;
  padding-inline-start: 16px !important;
}

.pb-16px {
  padding-bottom: 16px;
}

.pt-16px {
  padding-top: 16px;
  --padding-top: 16px;
}

.m-0 {
  margin: 0 !important;
}

.p-0 {
  padding: 0 !important;
}

.d-f-a-c {
  align-items: center;
  display: flex;
}

.three-dots {
  display: block;
  text-overflow: ellipsis;
  overflow: hidden;
  width: 100%;
  height: 100%;
  white-space: nowrap;
}

.title {
  padding: 20px;
  margin: 0;
  font-size: 16px;
}

.title-wrapper {
  width: 72%;
}

.select-hours-block h3 {
  font-family: "Roboto-Regular";
  color: #58585F;
}
.select-hours-block h3 .hours {
  color: #19A6FF;
}
.select-hours-block h3:nth-child(1) {
  margin-bottom: 0 !important;
}
.select-hours-block h3:nth-child(2) {
  margin-top: 16px !important;
  margin-bottom: 34px !important;
}
.select-hours-block .save-for-future {
  background-color: white;
  --background: white !important;
  margin-left: -30px;
  margin-right: -30px;
  padding: 15px 0;
  margin-top: 20px;
  --background-hover: none;
  --background-activated: none;
  --ripple-color: transparent;
}
.select-hours-block .save-for-future ion-checkbox {
  position: relative;
}
.select-hours-block .save-for-future ion-label {
  font-size: 0.9rem;
  color: var(--vl-black-font);
  white-space: initial;
}
.select-hours-block .save-for-future .description {
  font-size: 0.7rem;
}
.select-hours-block .save-for-future .description .hours {
  color: #19A6FF;
}
.select-hours-block .plus-minus-btn {
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--vl-black-font);
}
.select-hours-block .plus-minus-btn vl-icon {
  height: 24px;
  width: 24px;
  margin-bottom: 5px;
}
.select-hours-block .row {
  background-color: white;
  z-index: 1000;
}
.select-hours-block .row input {
  height: 30px;
  border-radius: 0;
  box-shadow: none;
  width: 100%;
  font-size: 0.7rem;
  border: 1px solid #DDDEE3;
  text-align: center;
  color: var(--vl-black-font);
}
.select-hours-block .row .col-6 {
  width: 40px;
}
.select-hours-block .row .col-3 {
  display: flex;
}
.select-hours-block .row .col-3:first-child {
  justify-content: flex-end;
}
.select-hours-block .row .col-3:last-child {
  justify-content: flex-start;
}

.back-btn {
  padding-left: 0 !important;
  padding-bottom: 20px;
  margin-left: -8px;
}

ion-list {
  --background: var(--vl-bg-dark) !important;
  background: var(--vl-bg-dark) !important;
  margin: 0 -30px;
  overflow-y: auto;
  padding: 0;
}
ion-list.margin-bottom {
  margin-bottom: 80px;
}
ion-list ion-item {
  --min-height: 54px;
  --background: white !important;
  --border: none;
  border-bottom: 1px solid #EDEEF3;
  --padding-start: 20px;
}
ion-list ion-item.inner-padding {
  --inner-padding-top: 10px;
  --inner-padding-bottom: 10px;
}
ion-list ion-item ion-checkbox {
  z-index: 1000;
}
ion-list ion-item.giropay-form-wrapper {
  height: fit-content;
}
ion-list ion-item.giropay-form-wrapper .input-wrapper {
  width: 100%;
  margin-left: 16px !important;
  margin-bottom: 10px;
}
ion-list ion-item.giropay-form-wrapper input {
  width: 80%;
  margin-bottom: 10px;
  padding-left: 16px !important;
}
ion-list ion-item.giropay-form-wrapper ion-label {
  margin-left: 16px;
}
ion-list ion-item .img-wrapper {
  height: 53px;
  width: 50px;
  align-items: center;
  display: flex;
  margin: 0 10px;
}
ion-list ion-item .img-wrapper img {
  border-radius: 0 !important;
  width: 100%;
}
ion-list ion-item ion-icon, ion-list ion-item vl-icon {
  height: 100%;
  display: flex;
  align-items: center;
}
ion-list ion-item ::ng-deep vl-icon svg {
  stroke: var(--vl-red);
}
ion-list ion-item.card-view {
  border-top-left-radius: 25px;
  border-top-right-radius: 25px;
}

.contact-us {
  font-size: 18px;
  margin-top: 8px;
  font-family: "Roboto-Medium";
  color: #b5b5bc;
  padding-top: 30px;
}
.contact-us span {
  text-decoration: underline;
  font-size: 12px;
  color: var(--vl-red);
  padding-top: 10px;
}

.disabled-stripe {
  color: var(--vl-red);
  font-size: 0.7rem;
  opacity: 0.7;
}

.add-card-container {
  height: 100%;
}
.add-card-container ion-label {
  margin: 0 10px;
}

.fixed-content-wrapper {
  position: fixed;
  bottom: 0;
  width: 85%;
}

vl-pay-with-wrapper ::ng-deep vl-pay-with-giropay form {
  display: none;
}

.custom-btn-block {
  margin-bottom: 16px;
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/_vl-variables.scss","webpack://./src/app/modules/payment/components/choose-free-hours/choose-free-hours.component.scss"],"names":[],"mappings":"AAgBA;EACE,4BAXc;ACJhB;;ADmBA;EACE,kBAZe;EAaf,mBAbe;ACHjB;;ADmBA;EACE,iBAjBe;EAkBf,oBAlBe;ACEjB;;ADmBA;EACE,aAtBe;ACMjB;;ADmBA;EACE,8BAAA;EACA,mCAAA;AChBF;;ADmBA;EACE,6BAAA;EACA,qCAAA;AChBF;;ADmBA;EACE,oBAAA;AChBF;;ADmBA;EACE,iBAAA;EACA,mBAAA;AChBF;;ADmBA;EACE,oBAAA;AChBF;;ADmBA;EACE,qBAAA;AChBF;;ADmBA;EACE,mBAAA;EACA,aAAA;AChBF;;ADmBA;EACE,cAAA;EACA,uBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AChBF;;AAvDA;EACE,aAAA;EACA,SAAA;EACA,eAAA;AA0DF;;AAxDA;EACE,UAAA;AA2DF;;AAxDE;EACE,6BDJa;ECKb,cAAA;AA2DJ;AAzDI;EACE,cAAA;AA2DN;AAxDI;EACE,2BAAA;AA0DN;AAvDI;EACE,2BAAA;EACA,8BAAA;AAyDN;AArDE;EACE,uBAAA;EACA,8BAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,wBAAA;EACA,4BAAA;EACA,2BAAA;AAuDJ;AAtDI;EACE,kBAAA;AAwDN;AArDI;EACE,iBAAA;EACA,2BAAA;EACA,oBAAA;AAuDN;AArDI;EACE,iBAAA;AAuDN;AAtDM;EACE,cAAA;AAwDR;AAnDE;EACE,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,2BAAA;AAqDJ;AAnDI;EACE,YAAA;EACA,WAAA;EACA,kBAAA;AAqDN;AAjDE;EACE,uBAAA;EAGA,aAAA;AAiDJ;AA/CI;EACE,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,2BAAA;AAiDN;AA/CI;EACE,WAAA;AAiDN;AA9CI;EACE,aAAA;AAgDN;AA9CM;EACE,yBAAA;AAgDR;AA7CM;EACE,2BAAA;AA+CR;;AAzCA;EACE,0BAAA;EACA,oBAAA;EACA,iBAAA;AA4CF;;AArCA;EACE,0CAAA;EACA,wCAAA;EACA,eAAA;EAEA,gBAAA;EAIA,UAAA;AAoCF;AAvCE;EACE,mBAAA;AAyCJ;AAtCE;EACE,kBAAA;EASA,8BAAA;EAmBA,cAAA;EAEA,gCAAA;EACA,qBAAA;AAaJ;AA3CI;EACE,yBAAA;EACA,4BAAA;AA6CN;AA3CI;EACE,aAAA;AA6CN;AAzCI;EACE,mBAAA;AA2CN;AA1CM;EACE,WAAA;EACA,4BAAA;EACA,mBAAA;AA4CR;AA1CM;EACE,UAAA;EACA,mBAAA;EACA,6BAAA;AA4CR;AA1CM;EACE,iBAAA;AA4CR;AAlCI;EACE,YAAA;EACA,WAAA;EACA,mBAAA;EACA,aAAA;EACA,cAAA;AAoCN;AAnCM;EACE,2BAAA;EACA,WAAA;AAqCR;AAjCI;EACE,YAAA;EACA,aAAA;EACA,mBAAA;AAmCN;AA/BM;EACE,qBAAA;AAiCR;AA7BI;EACE,4BAAA;EACA,6BAAA;AA+BN;;AA1BA;EACE,eAAA;EACA,eAAA;EACA,4BD1Lc;EC2Ld,cAAA;EACA,iBAAA;AA6BF;AA5BE;EACE,0BAAA;EACA,eAAA;EACA,oBAAA;EACA,iBAAA;AA8BJ;;AA1BA;EACE,oBAAA;EACA,iBAAA;EACA,YAAA;AA6BF;;AA1BA;EACE,YAAA;AA6BF;AA5BE;EACE,cAAA;AA8BJ;;AA1BA;EACE,eAAA;EACA,SAAA;EACA,UAAA;AA6BF;;AAxBM;EACE,aAAA;AA2BR;;AArBA;EACE,mBAAA;AAwBF","sourcesContent":["$red: #EB0000;\n$black: #262627;\n\n$font-path: \"~roboto-fontface/fonts/roboto/\";\n$font-format: 'woff';\n$roboto-bold: \"Roboto-Bold\";\n$roboto-medium: \"Roboto-Medium\";\n$roboto-light: \"Roboto-Light\";\n$roboto-regular: \"Roboto-Regular\";\n\n$global-padding: 16px;\n$global-padding-with-fixed-button: 108px;\n$toolbar-height: 70px;\n$modal-height: 425px;\n$edit-phone-email-modal-height: 325px;\n\nion-button {\n  font-family: $roboto-medium;\n}\n\n\n.px-16px {\n  padding-left: $global-padding;\n  padding-right: $global-padding;\n}\n\n.py-16px {\n  padding-top: $global-padding;\n  padding-bottom: $global-padding;\n}\n\n.p-16px {\n  padding: $global-padding;\n}\n\n.pr-16px {\n  padding-right: $global-padding !important;\n  padding-inline-end: $global-padding !important;\n}\n\n.pl-16px {\n  padding-left: $global-padding !important;\n  padding-inline-start: $global-padding !important;\n}\n\n.pb-16px {\n  padding-bottom: 16px;\n}\n\n.pt-16px {\n  padding-top: 16px;\n  --padding-top: 16px;\n}\n\n.m-0 {\n  margin: 0 !important;\n}\n\n.p-0 {\n  padding: 0 !important;\n}\n\n.d-f-a-c {\n  align-items: center;\n  display: flex;\n}\n\n.three-dots {\n  display: block;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  width: 100%;\n  height: 100%;\n  white-space: nowrap;\n}\n","@use \"/src/assets/scss/vl-variables\" as *;\n\n.title {\n  padding: 20px;\n  margin: 0;\n  font-size: 16px;\n}\n.title-wrapper {\n  width: 72%;\n}\n.select-hours-block {\n  h3 {\n    font-family: $roboto-regular;\n    color: #58585F;\n\n    .hours {\n      color: #19A6FF;\n    }\n\n    &:nth-child(1) {\n      margin-bottom: 0 !important;\n    }\n\n    &:nth-child(2) {\n      margin-top: 16px !important;\n      margin-bottom: 34px !important;\n    }\n  }\n\n  .save-for-future {\n    background-color: white;\n    --background: white !important;\n    margin-left: -30px;\n    margin-right: -30px;\n    padding: 15px 0;\n    margin-top: 20px;\n    --background-hover: none;\n    --background-activated: none;\n    --ripple-color: transparent;\n    ion-checkbox {\n      position: relative;\n    }\n\n    ion-label {\n      font-size: 0.9rem;\n      color: var(--vl-black-font);\n      white-space: initial;\n    }\n    .description {\n      font-size: 0.7rem;\n      .hours {\n        color: #19A6FF;\n      }\n    }\n  }\n\n  .plus-minus-btn {\n    background-color: white;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: var(--vl-black-font);\n\n    vl-icon {\n      height: 24px;\n      width: 24px;\n      margin-bottom: 5px;\n    }\n  }\n\n  .row {\n    background-color: white;\n    // padding-bottom: 16px;\n    // margin: 0 -30px;\n    z-index: 1000;\n\n    input {\n      height: 30px;\n      border-radius: 0;\n      box-shadow: none;\n      width: 100%;\n      font-size: 0.7rem;\n      border: 1px solid #DDDEE3;\n      text-align: center;\n      color: var(--vl-black-font);\n    }\n    .col-6 {\n      width: 40px;\n    }\n\n    .col-3 {\n      display: flex;\n\n      &:first-child {\n        justify-content: flex-end;\n      }\n\n      &:last-child {\n        justify-content: flex-start;\n      }\n    }\n  }\n}\n\n.back-btn {\n  padding-left: 0 !important;\n  padding-bottom: 20px;\n  margin-left: -8px;\n}\n\ninput {\n  // pointer-events: none;\n}\n\nion-list {\n  --background: var(--vl-bg-dark) !important;\n  background: var(--vl-bg-dark) !important;\n  margin: 0 -30px;\n  // max-height: 300px;\n  overflow-y: auto;\n  &.margin-bottom {\n    margin-bottom: 80px;\n  }\n  padding: 0;\n  ion-item {\n    --min-height: 54px;\n    &.inner-padding {\n      --inner-padding-top: 10px;\n      --inner-padding-bottom: 10px;\n    }\n    ion-checkbox {\n      z-index: 1000;\n    }\n    //--background: rgb(88 179 237 / 20%);\n    --background: white !important;\n    &.giropay-form-wrapper {\n      height: fit-content;\n      .input-wrapper {\n        width: 100%;\n        margin-left: 16px !important;\n        margin-bottom: 10px;\n      }\n      input {\n        width: 80%;\n        margin-bottom: 10px;\n        padding-left: 16px !important;\n      }\n      ion-label {\n        margin-left: 16px;\n      }\n      // --background: var(--vl-bg-dark) !important;\n    }\n    //border-radius: 10px;\n    --border: none;\n    //box-shadow: 0 5px 9px rgba(0, 0, 0, .07), 0 0 5px rgba(0, 0, 0, .04);\n    border-bottom: 1px solid #EDEEF3;\n    --padding-start: 20px;\n\n    .img-wrapper {\n      height: 53px;\n      width: 50px;\n      align-items: center;\n      display: flex;\n      margin: 0 10px;\n      img {\n        border-radius: 0 !important;\n        width: 100%;\n      }\n    }\n\n    ion-icon, vl-icon {\n      height: 100%;\n      display: flex;\n      align-items: center;\n    }\n\n    ::ng-deep vl-icon {\n      svg {\n        stroke: var(--vl-red);\n      }\n    }\n\n    &.card-view {\n      border-top-left-radius: 25px;\n      border-top-right-radius: 25px;\n    }\n  }\n}\n\n.contact-us {\n  font-size: 18px;\n  margin-top: 8px;\n  font-family: $roboto-medium;\n  color:#b5b5bc;\n  padding-top: 30px;\n  span {\n    text-decoration: underline;\n    font-size: 12px;\n    color: var(--vl-red);\n    padding-top: 10px;\n  }\n}\n\n.disabled-stripe {\n  color: var(--vl-red);\n  font-size: 0.7rem;\n  opacity: 0.7;\n}\n\n.add-card-container {\n  height: 100%;\n  ion-label {\n    margin: 0 10px;\n  }\n}\n\n.fixed-content-wrapper {\n  position: fixed;\n  bottom: 0;\n  width: 85%;\n}\nvl-pay-with-wrapper  {\n  ::ng-deep {\n    vl-pay-with-giropay {\n      form {\n        display: none;\n      }\n    }\n  }\n}\n\n.custom-btn-block {\n  margin-bottom: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
